import I18n from "i18n-js";
import { FullName } from "../../ordering";
import { makeImmutable, toPairs } from "../../core";
import { Email, ErrorBox, PhoneFieldControler, TextFieldControler, } from "../../form";
export class OnlineContactFormControler {
    constructor(params) {
        var _a, _b, _c, _d, _e;
        this.type = "Online";
        this.contactDetails = params.contactDetails;
        this.fullName = new TextFieldControler({
            initialValue: (_b = (_a = this.contactDetails.fullName) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "",
            update: (str) => (this.contactDetails.fullName = new FullName(str)),
            errorBox: new ErrorBox({
                domainObjects: [this.contactDetails],
                errorMessages: {
                    FullNameMissing: I18n.t("_common.form.errors.required"),
                    InvalidFullName: I18n.t("errors.messages.invalid"),
                },
            }),
        });
        this.email = new TextFieldControler({
            initialValue: ((_c = this.contactDetails.email) === null || _c === void 0 ? void 0 : _c.value) || "",
            update: (str) => (this.contactDetails.email = new Email(str)),
            errorBox: new ErrorBox({
                domainObjects: [this.contactDetails],
                errorMessages: {
                    EmailMissing: I18n.t("_common.form.errors.required"),
                    InvalidEmail: I18n.t("validations.invalid_email"),
                },
            }),
        });
        this.phone = new PhoneFieldControler({
            initialValue: (_e = (_d = this.contactDetails.phone) === null || _d === void 0 ? void 0 : _d.value) !== null && _e !== void 0 ? _e : "",
            update: (str, country) => {
                this.contactDetails.setPhone(str, country);
            },
            errorBox: new ErrorBox({
                domainObjects: [this.contactDetails],
                errorMessages: {
                    PhoneMissing: I18n.t("_common.form.errors.required"),
                    InvalidPhoneNumber: I18n.t("activerecord.errors.models.order.attributes.user.attributes.parsed_phone.invalid"),
                },
            }),
        });
        makeImmutable(this);
    }
    get fields() {
        return {
            fullName: this.fullName,
            email: this.email,
            phone: this.phone,
        };
    }
    touch() {
        toPairs(this.fields).forEach(([, field]) => field.onBlur());
    }
}
